import { CustomerControllerCreateMethod } from '../methods/customer-controller/create.method';
import { CustomerControllerGetByIdMethod } from '../methods/customer-controller/get-by-id.method';
import { CustomerControllerGetPaginatedMethod } from '../methods/customer-controller/get-paginated.method';

export class CustomerController {
  public readonly create = new CustomerControllerCreateMethod();
  public readonly getPaginated = new CustomerControllerGetPaginatedMethod();
  public readonly getById = new CustomerControllerGetByIdMethod();
}
